import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Tengo que comprar alimentos caros o raros?',
    a: 'No. Todo lo que necesitas está en tu supermercado local. Se trata de cómo y cuándo comes, no de encontrar ingredientes exóticos.'
  }, {
    q: '¿Es apto para vegetarianas?',
    a: 'Sí. El protocolo se basa en nutrientes, no en un solo tipo de proteína. Puedes adaptarlo perfectamente a tus preferencias.'
  }, {
    q: '¿Cuánto tiempo tardaré en ver resultados?',
    a: 'La mayoría de las mujeres reportan una reducción notable de la inflamación abdominal en los primeros 4 a 7 días de comenzar el protocolo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-cream-dark border-t border-sage/10" data-id="element-49">
      <div className="max-w-3xl mx-auto" data-id="element-50">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-dark mb-12" data-id="element-51">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-52">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-2xl border border-sage/20 overflow-hidden shadow-sm" data-id="element-53">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-54">
                <span className="font-bold text-dark text-lg pr-4" data-id="element-55">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-sage transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-56" />
              </button>

              <AnimatePresence data-id="element-57">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-58">
                    <div className="px-6 pb-5 text-dark-light leading-relaxed" data-id="element-59">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}